<template>
  <Walkthrough 
    roomName="Bureau"
    roomKey="office"
    :steps="steps"
    :backgroundImage="backgroundImage"
    language="french"
  />
</template>
<script>

export default {
  name: 'Oficina',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/office-1920x1280.jpg",
      steps: [
        "Regardez à gauche, puis regardez le bureau.",
        "Maintenant que vous savez qu'il y a une lettre sur le bureau, regardez la lettre.",
        "La lettre contient des indices sur le disjoncteur. Notez les quatre objets dans la pièce mentionnée dans la lettre, et l'ordre dans lequel ils apparaissent. Ensuite, regardez ces objets dans la pièce et identifiez leurs couleurs.",
        "Maintenant que vous connaissez les quatre couleurs, regardez à droite et inspectez le disjoncteur. Vous pouvez maintenant entrer les couleurs vert, rouge, bleu, blanc et le courant devrait commencer à circuler dans la pièce. Cela vous sera utile plus tard.",
        "Maintenant, regardez en bas et inspectez la trappe. Vous devriez trouver un pied-de-biche à l'intérieur.",
        "Maintenant que vous avez le pied-de-biche, regardez à gauche sur le bureau et utilisez le pied-de-biche sur le tiroir. Vous devriez trouver un tournevis.",
        "Maintenant que vous avez le tournevis, vous pouvez regarder vers le haut et utiliser le tournevis sur la bouche d’aération. A l'intérieur vous devriez trouver un marteau.",
        "Avec le marteau que vous avez maintenant, vous pouvez regarder à gauche et utiliser le marteau pour casser le cadre en verre épais autour de la photo. Ceci devrait révéler un message au dos.",
        "En utilisant le message que vous avez trouvé au dos de la photo, vous devriez avoir accès à l'âge des filles (5 ans), et la date de la photo (1995) pour l'utiliser comme mot de passe pour lecoffre, 0390 (l'anniversaire de la fille, Mars 1990)",
        "Regardez à droite et inspectez le coffre-fort. Vous devez entrer le code 0390 dans le coffre-fort et trouver la clé finale !",
        "En utilisant la clé, vous pouvez maintenant regarder vers l'avant, utiliser la clé sur la porte, et obtenir votre liberté. Félicitations pour votre évasion. Essayez de résoudre l’énigme de la pièce d'à côté par vos propres moyens !"
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/walkthrough/fr/office.vue